<template>
<div class="popup" v-cloak v-if="changeNameShow">
    <div class="content" id="changeName">
        <div class="title" style="border-radius: 9px 9px 0 0;">
            {{$t('language.popup.personalCenter.changeName')}}
            <div class="icon white-close dialog-close" @click="changeNameShow=false"></div>
        </div>
        <div class="personInfo-content">
            <div class="personInfo-column">
                <span> {{$t('language.common.emailAccount')}}</span>
                <span>{{$t('language.popup.addCloudPopup.userName')}}</span>
            </div>
            <div class="personInfo-column personInfo-column-msg">
                <p :title="email">{{email}}</p>
                <input type="text" @blur="verificationName()" v-model="userName"/>
            </div>

            <button class="personInfo-button" @click.stop="changeName()" :class="userName?'':'button-noclick'">{{$t('language.common.save')}}</button>

        </div>
    </div>

</div>
</template>

<script>
import commonstate from '@/js/constant.js';
import commonUtils from "@/js/workspace/common_util.js";
export default {
    data: function () {
        return {
            changeNameShow: false,
            email: '',
            userName: '',
        }
    },
    watch: {
        changeNameShow(newValue,oldValue){
            if(newValue){
                 let user = commonUtils.getUser();
                this.userName = user.username;
            }
        }
    },
    created() {
        let user = commonUtils.getUser();
        if(user){
            if(user.loginType&&user.loginType!="sub"&&!(commonstate.activeLoginTypeList.includes(user.loginType))&&!(commonstate.channelTypeList.includes(user.loginType))){
              this.email = user.email.replace("T","");
             }else{
             this.email = user.email
             }
            this.userName = user.username;
        }
    },
    methods: {
        verificationName() {
            if (!this.userName) {
                this.$toast({
                    text:  this.$t('language.login.userNameNot'),
                    type: 'fail',
                    idValue: "changeName"
                });
            }
        },
        changeName() {
            let user = commonUtils.getUser();
            let email=this.email;
            if(user.loginType&&user.loginType!="sub"&&!(commonstate.activeLoginTypeList.includes(user.loginType))&&!(commonstate.channelTypeList.includes(user.loginType))){
                 email = "T"+email;
            }
            let changeData;
            if (!this.userName.trim()) {
                this.$toast({
                    text:  this.$t('language.login.userNameNot'),
                    type: 'fail',
                    idValue: "changeName"
                });
                return false;
            }
            if(this.userName.length>20){
                  this.$toast({
                    text: this.$t('language.exception.nameLong'),
                    type: 'fail',
                    idValue: "changeName"
                });
                return false;
            }
            changeData = {
                ud: commonUtils.getUser().id,
                email: email.trim(),
                username: this.userName.trim().replace(/\s+/ig, " "),
            }
            this.Utils.doUserHaveLoginRequest("update", changeData).then(res => {
                if (res.status == 200) {
                    commonUtils.refreshUserInfo(this,function(res){});
                    this.$toast({
                        text:  this.$t('language.login.updatedSuccessfully'),
                        type: 'success',
                        idValue: "rightContBan"
                    });
                    this.changeNameShow = false;
                } else {
                    if(res.reason&&res.reason=='saltInvalid'){
                    this.$toast({
                        text: this.$t('language.exception.' + res.reason),
                        type: 'fail',
                        idValue: "rightContBan"
                    });
                    }else{
                      this.$toast({
                        text: this.$t('language.popup.remindBindEmail.failed'),
                        type: 'fail',
                        idValue: "rightContBan"
                    });   
                    }
                }

            });
        },
    }
}
</script>

<style>
#changeName {
    width: 500px;
    /*no*/
    height: 260px;
    /*no*/
    border-radius: 10px;/*no*/
}

.personInfo-content {
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
    /*no*/
    color: #6f7886;
    font-size: 14px;
    /*no*/
    position: relative;
    display: inline-flex;
}

.personInfo-column {
    display: inline-flex;
    flex-direction: column;
}

.personInfo-column-msg {
    flex: 1;
    padding-left: 20Px;
}

.personInfo-column-msg p{
    margin: 17Px 0;
    padding-left: 10Px;
    word-break: break-word;
}

.personInfo-column span {
    line-height: 50Px;
    color: #000000;
    font-weight: 400;
}

.personInfo-column input {
    margin: 8Px 0;
    border-radius: 6Px;
    font-size: 14px;/*no*/
    font-family: Helvetica;
    line-height: 24px;/*no*/
    color: #6F7886;
}

</style>



// WEBPACK FOOTER //
// src/components/popup/personal_center_popups/change_name_popup.vue